import prePopulateForm from 'root/src/client/logic/form/actions/prePopulateForm'
import prePopulateDataSelector from 'root/src/client/logic/form/selectors/prePopulateDataSelector'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (moduleKey, { overwrite }) => (dispatch, getState) => {
	const moduleId = moduleIdFromKey(moduleKey)
	const state = getState()
	const prePopulateData = prePopulateDataSelector(state, { moduleId })
	if (prePopulateData) {
		dispatch(prePopulateForm({ moduleKey, formData: prePopulateData, overwrite }))
	}
}
